
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatNumber = (num: number | string | undefined) => {
  if (!num) return 0;
  return Number(num).toLocaleString(undefined, {
    maximumSignificantDigits: 6,
    notation: "compact",
  });
};
